var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"signIn"}},[_c('appHeader',{attrs:{"title":'顧客查詢',"targetRouterName":_vm.route}}),_c('router-view',{staticClass:"content-body"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }